import { render } from "./MLayer.vue?vue&type=template&id=07bdc471&scoped=true"
import script from "./MLayer.vue?vue&type=script&lang=js"
export * from "./MLayer.vue?vue&type=script&lang=js"

import "./MLayer.vue?vue&type=style&index=0&id=07bdc471&lang=scss&scoped=true"
import "./MLayer.vue?vue&type=style&index=1&id=07bdc471&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bdc471"]])

export default __exports__